<template>
  <div style="padding:20px;">
    <!-- 外层筛选与查询 -->
    <div style="margin-bottom:12px;">
      <el-select v-model="selectedProject" placeholder="选择项目" style="width:260px;">
        <el-option v-for="p in projectList" :key="p" :label="p" :value="p"></el-option>
      </el-select>
      <el-button type="primary" :loading="queryLoading" @click="doAnalyze">查询</el-button>

      <el-button type="success" @click="openManager" style="margin-left:10px;">项目管理</el-button>

      <el-button type="info" :disabled="!analyzeList.length" style="margin-left:10px;" @click="exportExcel">
        导出数据
      </el-button>
    </div>

    <!-- 加载提示 -->
    <div v-if="queryLoading" style="margin:15px 0; color:#409EFF;">正在查询中，请稍候...</div>

    <!-- 分析结果表 -->
    <el-table v-if="analyzeList.length" :data="analyzeList" border style="width:100%;">
      <el-table-column prop="project_name" label="项目名"></el-table-column>
      <el-table-column prop="client_name" label="客户名"></el-table-column>
      <el-table-column prop="spent" label="总消耗"></el-table-column>
      <el-table-column prop="formsubmitCount" label="总表单数"></el-table-column>
      <el-table-column prop="cpFormsubmit" label="总表单成本"></el-table-column>
      <el-table-column prop="backRegisterC" label="总注册数"></el-table-column>
      <el-table-column prop="cpBackRegisterC" label="总注册成本"></el-table-column>

      <el-table-column prop="current_spent" label="当前时段消耗"></el-table-column>
      <el-table-column prop="current_form_cost" label="当前时段表单成本"></el-table-column>
      <el-table-column prop="current_register_cost" label="当前时段注册成本"></el-table-column>

      <el-table-column prop="last_spent" label="上个时段消耗"></el-table-column>
      <el-table-column prop="last_form_cost" label="上个时段表单成本"></el-table-column>
      <el-table-column prop="last_register_cost" label="上个时段注册成本"></el-table-column>
    </el-table>

    <!-- 管理弹窗 -->
    <el-dialog title="项目管理" :visible.sync="managerVisible" width="80%" @open="loadPageData">
      <div style="margin-bottom:10px;">
        <el-button type="primary" @click="addRow">单个添加</el-button>
      </div>

      <el-table :data="tableData" border style="width:100%;">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column label="项目名">
          <template slot-scope="scope">
            <el-input v-model="scope.row.project_name" @input="markChanged(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="客户名">
          <template slot-scope="scope">
            <el-input v-model="scope.row.client_name" @input="markChanged(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="密钥">
          <template slot-scope="scope">
            <el-input v-model="scope.row.secret_key" @input="markChanged(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeRow(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="managerVisible = false">取消</el-button>
        <el-button type="primary" @click="saveManagerChanges">保存修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
import FileSaver from "file-saver";

export default {
  data: function() {
    return {
      userId: this.$route.query.userId,
      projectList: [],
      selectedProject: "",
      analyzeList: [],
      queryLoading: false,
      managerVisible: false,
      tableData: [],
      originalMap: {},
      changedSet: {},
      tempIndexCounter: 0
    };
  },
  created: function() {
    this.loadProjectList();
  },
  methods: {
    // 加载项目名列表（带 userId）
    loadProjectList: function() {
      var that = this;
      axios.get("https://control.zjwec.cn/api/vivo/projectNames", { params: { userId: that.userId } })
          .then(function(resp) {
            if (resp.data && resp.data.data) that.projectList = resp.data.data;
          })
          .catch(function() {});
    },

    // 查询分析数据
    doAnalyze: function() {
      var that = this;
      if (!that.selectedProject) {
        that.$message.warning("请选择项目名");
        return;
      }
      that.queryLoading = true;
      that.analyzeList = [];
      axios.get("https://control.zjwec.cn/api/vivo/analyze", {
        params: { userId: that.userId, projectName: that.selectedProject }
      }).then(function(resp) {
        that.queryLoading = false;
        if (resp.data && resp.data.data) {
          that.analyzeList = resp.data.data;
        } else {
          that.analyzeList = [];
        }
      }).catch(function() {
        that.queryLoading = false;
        that.$message.error("查询失败");
      });
    },

    // 导出分析数据为 Excel
    // 导出分析数据为 Excel（中文表头）
    exportExcel: function () {
      var that = this;
      if (!that.analyzeList || !that.analyzeList.length) {
        that.$message.warning("没有可导出的数据");
        return;
      }

      try {
        // 定义字段与中文列名对应关系
        var headers = [
          { key: "project_name", label: "项目名" },
          { key: "client_name", label: "客户名" },
          { key: "spent", label: "总消耗" },
          { key: "formsubmitCount", label: "总表单数" },
          { key: "cpFormsubmit", label: "总表单成本" },
          { key: "backRegisterC", label: "总注册数" },
          { key: "cpBackRegisterC", label: "总注册成本" },
          { key: "current_spent", label: "当前时段消耗" },
          { key: "current_form_cost", label: "当前时段表单成本" },
          { key: "current_register_cost", label: "当前时段注册成本" },
          { key: "last_spent", label: "上个时段消耗" },
          { key: "last_form_cost", label: "上个时段表单成本" },
          { key: "last_register_cost", label: "上个时段注册成本" }
        ];

        // 生成数据表（数值字段转数字类型）
        var data = [];
        for (var i = 0; i < that.analyzeList.length; i++) {
          var item = that.analyzeList[i];
          var row = {};
          for (var j = 0; j < headers.length; j++) {
            var h = headers[j];
            var val = item[h.key];
            if (val === null || val === undefined || val === "") {
              row[h.label] = "";
            } else if (!isNaN(val) && val !== "") {
              // 转为数值类型（保持 0）
              row[h.label] = Number(val);
            } else {
              row[h.label] = val;
            }
          }
          data.push(row);
        }

        // 转成 Sheet
        var ws = XLSX.utils.json_to_sheet(data);

        // 设置列样式（数字列右对齐、保留2位小数）
        var range = XLSX.utils.decode_range(ws["!ref"]);
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var header = ws[XLSX.utils.encode_cell({ r: 0, c: C })].v;
          // 检测是否数字列
          if (
            /消耗|成本|数$/.test(header)
          ) {
            for (var R = 1; R <= range.e.r; ++R) {
              var cellAddr = XLSX.utils.encode_cell({ r: R, c: C });
              var cell = ws[cellAddr];
              if (cell && typeof cell.v === "number") {
                cell.t = "n"; // 指定为数值类型
                cell.z = "0.00"; // 显示两位小数
              }
            }
          }
        }

        // 新建工作簿
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "分析数据");

        // 文件名
        var now = new Date();
        var fileName =
          "分析数据_" +
          now.getFullYear() +
          "-" +
          (now.getMonth() + 1) +
          "-" +
          now.getDate() +
          "_" +
          now.getHours() +
          "-" +
          now.getMinutes() +
          ".xlsx";

        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          fileName
        );

        that.$message.success("导出成功");
      } catch (e) {
        that.$message.error("导出失败");
        console.error(e);
      }
    }
,

    // 打开管理弹窗
    openManager: function() {
      this.managerVisible = true;
      this.loadPageData();
    },

    // 加载项目分页数据
    loadPageData: function() {
      var that = this;
      axios.get("https://control.zjwec.cn/api/vivo/page", { params: { userId: that.userId, page: 1, size: 1000 } })
          .then(function(resp) {
            var records = [];
            if (resp.data && resp.data.data && resp.data.data.records) {
              records = resp.data.data.records;
            } else if (resp.data && resp.data.records) {
              records = resp.data.records;
            } else {
              records = resp.data;
            }
            that.tableData = records || [];
            that.originalMap = {};
            that.changedSet = {};
            for (var i = 0; i < that.tableData.length; i++) {
              var item = that.tableData[i];
              if (item.id) {
                that.originalMap[String(item.id)] = JSON.stringify(item);
              } else {
                var key = "_tmp_" + (++that.tempIndexCounter);
                item._tempKey = key;
                that.originalMap[key] = JSON.stringify(item);
              }
            }
          }).catch(function() {
        that.$message.error("加载失败");
      });
    },

    // 标记修改
    markChanged: function(row) {
      var key = row.id ? String(row.id) : row._tempKey;
      this.changedSet[key] = true;
    },

    // 新增行
    addRow: function() {
      var key = "_tmp_" + (++this.tempIndexCounter);
      var r = { id: null, project_name: "", client_name: "", secret_key: "", user_id: this.userId, _tempKey: key };
      this.tableData.unshift(r);
      this.originalMap[key] = JSON.stringify(r);
      this.changedSet[key] = true;
    },

    // 删除行
    removeRow: function(index, row) {
      var that = this;
      if (row.id) {
        axios.delete("https://control.zjwec.cn/api/vivo/delete/" + row.id)
            .then(function() {
              that.$message.success("删除成功");
              that.loadPageData();
              that.loadProjectList();
            })
            .catch(function() {
              that.$message.error("删除失败");
            });
      } else {
        that.tableData.splice(index, 1);
        if (row._tempKey) {
          delete that.originalMap[row._tempKey];
          delete that.changedSet[row._tempKey];
        }
      }
    },

    // 保存修改
    saveManagerChanges: function() {
      var that = this;
      var toSubmit = [];
      for (var i = 0; i < that.tableData.length; i++) {
        var item = that.tableData[i];
        var key = item.id ? String(item.id) : item._tempKey;
        var orig = that.originalMap[key];
        var curr = JSON.stringify(item);
        if (that.changedSet[key] || !orig || orig !== curr) {
          var copy = {};
          for (var k in item) {
            if (k === "_tempKey") continue;
            copy[k] = item[k];
          }
          toSubmit.push(copy);
        }
      }

      if (toSubmit.length === 0) {
        that.$message.info("没有变动，无需保存");
        return;
      }

      axios.post("https://control.zjwec.cn/api/vivo/saveOrUpdate", toSubmit)
          .then(function() {
            that.$message.success("保存成功");
            that.loadPageData();
            that.loadProjectList();
          })
          .catch(function() {
            that.$message.error("保存失败");
          });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/vivo/vivoYYZHQuery.vue